import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=46a6775d&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=46a6775d&prod&lang=less&scoped=true&"
import style1 from "./Detail.vue?vue&type=style&index=1&id=46a6775d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a6775d",
  null
  
)

export default component.exports